<div *ngFor="let group of productGroups">
    <div *ngIf="productGroupsToggled[group.productgroupid.toString()]">
        <div [className]="'product-group-label deepth-' + group.deepth" (click)="toggleSuborderedGroups(group)">
            <span class="product-number">
                {{group.productgroupnumber}}
            </span>
            <span class="text">
                {{group.productgroupname}}
            </span>
        </div>
        <div *ngFor="let product of groupsProducts(group)" >
            <div *ngIf="productsToggled[group.productgroupid.toString()]" [className]="'product-label deepth-' + group.deepth" (click)="selectProduct(product)">
                <span class="product-number">{{product.productnumber}}</span>
                <span>{{product.productservice}}</span>
            </div>
        </div>
    </div>
</div>